export function catalogSelect() {
  const select = document.querySelector(".js-catalog-select");
  const selectOpen = select.querySelector(".js-catalog-select-open");
  const selectPlaceholder = selectOpen.querySelector(
    ".catalog__select-placeholder"
  );
  const selectValue = selectOpen.querySelector("input");
  const selectOptions = select.querySelectorAll(".catalog__select-option");

  const closeHeight = 28;
  let openHeight = select.clientHeight;

  let open = false;

  init();

  function init() {
    open = false;
    select.style.height = `${closeHeight}px`;

    selectOpen.addEventListener("click", () => {
      if (open) {
        closeSelect();
      } else {
        openSelect();
      }
    });

    selectOptions.forEach((option) => {
      option.addEventListener("click", function () {
        const value = this.value;
        const placeholder = this.textContent;

        selectValue.value = value;
        selectPlaceholder.textContent = placeholder;

        option.disabled = true;

        [...selectOptions]
          .filter((opt) => opt != option)
          .map((opt) => (opt.disabled = false));

        closeSelect();
      });
    });
  }

  function closeSelect() {
    select.style.height = `${closeHeight}px`;
    open = false;
    select.classList.remove("active");
  }

  function openSelect() {
    select.style.height = `${openHeight}px`;
    open = true;
    select.classList.add("active");
  }
}
